import { render } from "./RewardsPoints.vue?vue&type=template&id=3f275553&scoped=true"
import script from "./RewardsPoints.vue?vue&type=script&lang=js"
export * from "./RewardsPoints.vue?vue&type=script&lang=js"

import "./RewardsPoints.vue?vue&type=style&index=0&id=3f275553&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f275553"]])

export default __exports__